
import { useNavigate } from "react-router-dom";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import * as React from 'react';
import { useState, useRef, useEffect } from 'react';
import './consignmentScreen.css';
import moment from 'moment';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD, PIT_ROLES } from '../../../common/constants';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { PRINT_DOWNLOAD_DATA, GET_CONSIGNMENT_DATA, GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN, CREATE_CONSIGNMENT, GET_STAKEHOLDER_BASIC_DETAILS_URN, GET_USER_DETAILS, GET_URN_LIST } from '../../../common/URLs';
import { Fab, Typography, Card, CardContent, Container, TextField, Grid, Box, Stack, Checkbox, FormHelperText, Tooltip, IconButton, Paper } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction } from '../../../common/commonValidations';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from "react-i18next";
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import { PrintIcon } from '../../../common/icons';
import apiClient from '../../../axios';


export default function ConsignmentCreation() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [consignmentDetails, setconsignmentDetails] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [selectedUrn, setSelectedUrn] = useState('');
    const [vehicleList, setVehicleList] = useState([]);
    const [userDetails, setUserDetails] = useState();
    const [emailId, setEmailId] = useState();
    const [stakeholderType, setStakeholderType] = useState('HIT');
    const [stakeHolder, setStakeHolder] = useState([]);
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [urnList, setUrnList] = useState([]);
    const [msg, setMsg] = useState('');

    const [driverName, setDriverName] = useState("");
    const [driverNameError, setDriverNameError] = useState("");

    const [driverlicensenumber, setDriverlicensenumber] = useState("");
    const [driverlicensenumberError, setDriverlicensenumberError] = useState("");

    const [driverContact, setDriverContact] = useState("");
    const [driverContactError, setDriverContactError] = useState("");

    const [comments, setComments] = useState("");
    const [characterLimit] = useState(500);

    const [vehicleNo, setVehicleNo] = useState("");
    const [vehicleNoError, setVehicleNoError] = useState("");

    const [vehicleCapacity, setVehicleCapacity] = useState("");
    const [vehicleCapacityError, setVehicleCapacityError] = useState("");
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [cofirmMessage, setConfirmMessage] = useState("");
    const [pickUpdate, setPickUpDate] = useState(null);
    const [showErrorMsg, setShowErrorMsg] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [selectedConsignments, setSelectedConsignments] = React.useState([]);
    const [totalQuantity, setTotalQuantity] = React.useState(0);
    const [downloadConsignment, setDownloadConsignment] = React.useState();
    const [noUrnError, setNoUrnError] = useState("");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    useEffect(() => {
        getconsignmentDetails();
        getUrnList();
    }, [stakeholderType]);


    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            setSelectedUrn(decoded.extension_URN);
            const email = decoded.emails?.[0];
            setEmailId(email);
        }
    }, [getLocalStorageItem('id_token')]);

    useEffect(() => {
        if (emailId) {
            getUserDetails();
        }
    }, [emailId]);

    function getUserDetails() {
        loaderService.showLoader();
        apiClient
            .post(GET_USER_DETAILS,
                {
                    "emailAddress": emailId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }



    const getconsignmentDetails = (urn, date) => {
        let data = {
            "pickUpDate": date ? date : null,
            "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : urn ? urn : ''
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(GET_CONSIGNMENT_DATA, data, { headers })
            .then(res => {
                setconsignmentDetails(res.data.consignmentDataList);
                loaderService.hideLoader();
            })
            .catch(function (err) {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);
            });
    };

    const getDriverDetails = () => {

        let data = {

            "urn": selectedUrn ? selectedUrn : 'URN',
            "type": stakeholderType

        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN, data, { headers })
            .then(res => {
                setDriverList(res.data.driverList)
                setVehicleList(res.data.vehicleList)
                loaderService.hideLoader();
            })
            .catch(function (err) {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);
            });
    };

    const getOwnerDetails = () => {

        let data = {

            "urn": selectedUrn ? selectedUrn : 'URN',
            "type": stakeholderType

        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(GET_STAKEHOLDER_BASIC_DETAILS_URN, data, { headers })
            .then(res => {
                setStakeHolder(res.data.stakeHolders);
                loaderService.hideLoader();
            })
            .catch(function (err) {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);
            });
    };


    const columns = [
        {
            field: 'rowSelect', // Change this to the actual ID field name
            headerName: '',
            width: 50,

            renderCell: (params) => (
                <Checkbox name="rowSelect" disabled={params.row.consignmentNumber ? true : false} checked={selectedConsignments.some(r => r.id === params.row.id)} value={params.row.checkBoxChecked} onChange={(e) => updateSelectedRows(e, params.row)} />
            ),
        },
        { field: 'scheduleNumber', headerName: 'Schedule Number', width: 250 },
        { field: 'scheduleLineNo', headerName: 'Schedule Line', width: 150 },
        { field: 'growerPO', headerName: 'Grower PO', width: 130 },
        { field: 'pickUpLocationURN', headerName: 'Pick-Up Location URN', width: 180 },
        { field: 'pickUpLocationName', headerName: 'Pick-Up Location Name', width: 180 },
        { field: 'pickUpLocationAddress', headerName: 'Pick-Up Location Address', width: 180 },
        {
            field: 'scheduledPickupDate', headerName: 'Scheduled pick-up date', width: 180,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'actualPickupDate', headerName: 'Actual Pick-Up Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'deliveryLocationURN', headerName: 'Delivery Location URN', width: 150 },
        { field: 'deliveryLocationName', headerName: 'Delivery Location Name', width: 150 },
        { field: 'deliveryLocationAddress', headerName: 'Delivery Location Address', width: 150 },
        {
            field: 'scheduledDeliveryDate', headerName: 'Scheduled Delivery Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'actualDeliveryDate', headerName: 'Actual Delivery Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'inventoryType', headerName: 'Type Of Inventory', width: 150 },
        { field: 'landId', headerName: 'Land ID', width: 150 },
        { field: 'loadingType', headerName: 'Type Of Loading(FTL/LTL)', width: 190 },
        { field: 'vehicleRegistration', headerName: 'Vehicle Registration', width: 150 },
        { field: 'driverName', headerName: 'Driver Name', width: 150 },
        { field: 'driverID', headerName: 'Driver License Number', width: 150 },
        { field: 'driverContact', headerName: 'Driver Contact', width: 150 },
        { field: 'scheduleWeight', headerName: 'Balance Quantity (MT)', width: 180 },
        { field: 'harvestingWeight', headerName: 'Harvesting Quantity (MT)', width: 180 },
        { field: 'scheduledConsignmentWeight', headerName: 'Consignment Quantity (MT)', width: 180 },
        { field: 'consignmentNumber', headerName: 'Consignment No', width: 150 },
        { field: 'comment', headerName: 'Consignment Comments(if any)', width: 180 },
        {
            field: 'Action', width: 120,
            renderCell: (params) => {
                return (
                    <Tooltip title="Print">
                        <IconButton
                            variant="contained"
                            color="primary"
                            onClick={() => getconsignmentdata(params.row.consignmentNumber)}
                            hidden={params.row.consignmentNumber === null}
                        >
                            <PrintIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];



    const consDetailsCol = [
        // { field: 'id', headerName: '', width: 5},
        { field: 'pickUpLocationName', headerName: 'Scheduled Pick-Up Location', width: 270 },
        { field: 'deliveryLocationName', headerName: 'Delivery Location', width: 250 },
        { field: 'scheduleWeight', headerName: 'Balance Quantity (MT)', width: 150 },
    ];

    const handleClose = () => {
        setShowErrorMsg("")
        setOpen(false);
    };

    const handleClose1 = () => {
        // setShowErrorMsg("")
        setOpen1(false);
        setOpen(true);
    };

    const handleYes = () => {

        setOpen1(false);
        setOpen(true);
        handleSplit();
    }

    const handleSplit = () => {

        let vehicalCapacityVal = Number(vehicleCapacity);
        let newConsigments = [];
        let consignmentSourceDetails = [];
        let schedulePlanData = null;
        let consignmentCreationRequest = {

            "consignmentType": stakeHolder[0].categoryName,
            "materialType": selectedConsignments[0].inventoryType === "RB" ? "RawBamboo" : selectedConsignments[0].inventoryType === "CB" ? "ChipBamboo" : "",
            "typeOfLoading": "FTL",
            "consignmentScheduleDate": selectedConsignments[0].scheduledPickupDate,
            "consignmentSourceType": stakeholderType,
            "consignmentSourceUrn": selectedUrn,
            "scheduledWeight": totalQuantity,
            "consignmentWeight": vehicalCapacityVal,
            "scheduleDeliveryTimestamp": selectedConsignments[0].scheduledDeliveryDate,
            "consignmentDestinationStakeholderUrn": selectedConsignments[0].deliveryLocationURN,
            "consignmentDestinationType": selectedConsignments[0].deliveryLocationType,
            "consignmentDestinationName": selectedConsignments[0].deliveryLocationName,
            "consignmentDestinationLocationName": selectedConsignments[0].deliveryLocationName,
            "consignmentDestinationLocationAddress": selectedConsignments[0].deliveryLocationAddress,
            "consignmentOwnerName": stakeHolder[0].name,
            "consignmentOwnerContactNo": stakeHolder[0].mobileNo,
            "vehicleRegNo": vehicleNo,
            "driverName": driverName,
            "driverLicenseNo": driverlicensenumber,
            "driverContact": driverContact,
            "vehicleCapacity": vehicleCapacity,
            "fiscalYear": selectedConsignments[0].fiscalYear,
            "month": selectedConsignments[0].month,
            "consignmentComments": comments,
            "transporterServicePO": selectedConsignments[0].transporterServicePO,
            "harvestorServicePO": selectedConsignments[0].harvestorServicePO,
        };
        selectedConsignments.forEach(element => {
            if (vehicalCapacityVal - Number(element.scheduleWeight) >= 0) {
                vehicalCapacityVal = vehicalCapacityVal - Number(element.scheduleWeight);
                let conSourceData = {
                    "weeklyScheduleNumber": element.scheduleNumber,
                    "scheduleId": element.id,
                    "scheduleLineNumber": element.scheduleLineNo,
                    "weightToBeLifted": element.scheduleWeight,
                    "sourceType": "Grower",
                    "sourceStakeholderUrn": element.pickUpLocationURN,
                    "sourceName": element.sourceName,
                    "sourceLocationName": element.pickUpLocationName,
                    "sourceLocationAddress": element.pickUpLocationAddress,
                    "sourceStakeholderPo": element.growerPO,
                    "landId": element.landId


                }
                consignmentSourceDetails.push(conSourceData);

            } else if (vehicalCapacityVal - Number(element.scheduleWeight) < 0) {

                if (vehicalCapacityVal > 0) {
                    let conSourceData = {
                        "weeklyScheduleNumber": element.scheduleNumber,
                        "scheduleLineNumber": element.scheduleLineNo,
                        "scheduleId": element.id,
                        "scheduleStakeholderUrn": element.scheduleStakeholderUrn,
                        "weightToBeLifted": vehicalCapacityVal,
                        "sourceType": "Grower",
                        "sourceStakeholderUrn": element.pickUpLocationURN,
                        "sourceName": element.sourceName,
                        "sourceLocationName": element.pickUpLocationName,
                        "sourceLocationAddress": element.pickUpLocationAddress,
                        "sourceStakeholderPo": element.growerPO,
                        "landId": element.landId

                    }
                    //ele.quantity = vehicalCapacityVal;
                    consignmentSourceDetails.push(conSourceData);
                    schedulePlanData = {
                        "monthlyPlanId": element.monthlyPlanId,
                        "scheduleId": element.id,
                        "scheduleStakeholderType": stakeholderType,
                        "scheduleStakeholderUrn": element.scheduleStakeholderUrn,
                        "weeklyScheduleNumber": element.scheduleNumber,
                        "scheduleLineNumber": element.scheduleLineNo,
                        "schedulePickupDate": element.scheduledPickupDate,
                        "scheduleRbCbQuantity": Number(element.scheduleWeight) - vehicalCapacityVal,
                        "firstPartyUrn": element.pickUpLocationURN,
                        "firstPartyType": "Grower",
                        "firstPartyName": element.pickUpName,
                        "firstPartyContactNo": element.pickUpContactNo,
                        "firstPartyLocationName": element.pickUpLocationName,
                        "firstPartyLocationAddress": element.pickUpLocationAddress,
                        "secondPartyUrn": element.deliveryLocationURN,
                        "secondPartyType": element.deliveryLocationType,
                        "secondPartyName": element.deliveryName,
                        "secondPartyContactNo": element.deliveryContactNo,
                        "secondPartyLocationName": element.deliveryLocationName,
                        "secondPartyLocationAddress": element.deliveryLocationAddress,
                        "scheduledDeliveryDate": element.scheduledDeliveryDate,
                        "isActualScheduleLine": false,
                        "isConsignmentCreated": false,
                        "chippingQuantity": 0,
                        "loadingQuantity": Number(element.scheduleWeight) - vehicalCapacityVal,
                        "poStpoNumber": element.growerPO,
                        "fiscalYear": element.fiscalYear,
                        "month": element.month,
                    }
                }
                //}
                //})


            }


        })
        let createConsignment = {
            "consignmentData": { ...consignmentCreationRequest, "consignmentSourceDetails": consignmentSourceDetails },
            "schedulePlanData": schedulePlanData,
            // "landId": scheduleItem.landId,
        }



        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(CREATE_CONSIGNMENT, createConsignment, { headers })
            .then(res => {
                setMsg(res.data)
                getconsignmentDetails('', null);
                loaderService.hideLoader();
            })
            .catch(function (err) {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);
            });

        //setconsignmentDetails([...consignmentDetails, ...newConsigments])
        setSelectedConsignments([]);
        setShowErrorMsg("")
        setVehicleCapacity("");
        setVehicleNo("");
        setDriverlicensenumber("");
        setDriverContact("");
        setDriverName("");
        setComments("");

        setOpen(false)
    }

    useEffect(() => {
        if (msg) {
            if (msg.isSuccess === true) {
                toast.success("Consignment Created Successfully")
            } else {
                toast.error(msg?.message ? msg?.message : "Error")
            }
        }
    }, [msg]);

    const handleSave = () => {
        //let totalQuantityVal = selectedConsignments.reduce((total, e) => (e.splitQty ? Number(e.splitQty) : e.quantity) + total, 0)
        if (vehicleCapacity === "") {
            setVehicleCapacityError("Please fill Vehicle Capacity");
            return;
        }

        if (vehicleNo === "") {
            setVehicleNoError("Please fill Vehicle Number");
            return;
        }

        if (driverContact === "") {
            setDriverContactError("Please fill Driver Contact Details");
            return;
        }

        if (driverName === "") {
            setDriverNameError("Please fill Driver Name");
            return;
        }

        if (driverlicensenumber === "") {
            setDriverlicensenumberError("Please fill Driver Lincese Number");
            return;
        }


        if (Number(vehicleCapacity) > totalQuantity) {
            setShowErrorMsg("Please Add more consignments to reach vehicle capacity")
        } else if (Number(vehicleCapacity) < totalQuantity) {
            setOpen(false);
            setOpen1(true);

        } else {

            handleSplit();
        }
    };



    const handleDateChange = (e) => {
        setPickUpDate(e?.format("YYYY-MM-DD"));
        getconsignmentDetails(selectedUrn, e.format("YYYY-MM-DD"));
        // getconsignmentDetails(e.format("YYYY-MM-DD"), null)
    }

    const onValueUrn = (e) => {
        setSelectedUrn(e.target.value)
        setNoUrnError("")
        getconsignmentDetails(e.target.value, pickUpdate);
        // getconsignmentDetails(null, e.target.value)
    }

    const viewurn = (e, selectedrow) => {
        if (selectedConsignments.length > 0 && selectedUrn) {
            getDriverDetails();
            getOwnerDetails();
            setOpen(true);
            setNoUrnError("")
        }
        else {
            setNoUrnError("Please select Stakeholder URN");
        }
    }

    const onConfirm = () => {
        handleConfirmClose();
        handleSave();
    }

    const onSaveButtonClick = () => {
        handleConfirmOpen();
    }

    // const updateSelectedRows = (event, row) => {
    //     let selectedRowsTemp = selectedConsignments;
    //     if (event.target.checked) {
    //         selectedRowsTemp.push(row)
    //     } else {
    //         selectedRowsTemp = selectedRowsTemp.filter(i => {
    //             if (i.id === row.id) {
    //                 return false;
    //             }
    //             return true;
    //         })
    //     }
    //     let totalQuantityVal = selectedRowsTemp.reduce((total, e) => Number(e.scheduleWeight) + total, 0)
    //     setTotalQuantity(totalQuantityVal);
    //     selectedRowsTemp.sort((a, b) => {
    //         if (Number(a.scheduleWeight) > Number(b.scheduleWeight)) {
    //             return -1;
    //         } else {
    //             return 1;
    //         }
    //     });
    //     setSelectedConsignments(selectedRowsTemp)

    // }
    // console.log("selectedRowsTemp", selectedConsignments)

    const updateSelectedRows = (event, row) => {
        setSelectedConsignments(prevSelectedRows => {
            if (event.target.checked) {
                // Add the entire row object to selectedRows if checked and update totalQty
                const newSelectedRows = [...prevSelectedRows, row];
                updateTotalQty(newSelectedRows);
                newSelectedRows.sort((a, b) => {
                    if (Number(a.scheduleWeight) > Number(b.scheduleWeight)) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
                return newSelectedRows;
            } else {
                // Remove the row object from selectedRows if unchecked and update totalQty
                const newSelectedRows = prevSelectedRows.filter(r => r.id !== row.id);
                updateTotalQty(newSelectedRows);
                newSelectedRows.sort((a, b) => {
                    if (Number(a.scheduleWeight) > Number(b.scheduleWeight)) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
                return newSelectedRows;
            }
        });
    };

    // Function to update the total quantity
    const updateTotalQty = (selectedRows) => {
        const total = selectedRows.reduce((total, e) => Number(e.scheduleWeight) + total, 0);
        setTotalQuantity(total);
    };

    const updateVehicleDetails = (e) => {
        e.target.value.length > 0 && setVehicleNoError("");
        setVehicleNo(e.target.value);
        let vehicleSelected = vehicleList.filter(vehicle => vehicle.registrationNo === e.target.value)
        setVehicleCapacity((Number(vehicleSelected?.[0]?.grossVehicleWeight) - Number(vehicleSelected?.[0]?.unladenWeight)) / 1000)
    }

    const updateDriverDetails = (e) => {
        e.target.value.length > 0 && setDriverlicensenumberError("");
        setDriverlicensenumber(e.target.value);
        let driverSelected = driverList.filter(driver => driver.driverLicenseId === e.target.value)
        setDriverName(driverSelected[0].driverName);
        setDriverContact(driverSelected[0].driverContactNo);
    }
    const setSplitQty = (val, row) => {
        row['splitQty'] = val;
    }

    const getconsignmentdata = (num) => {
        loaderService.showLoader();
        apiClient
            .post(PRINT_DOWNLOAD_DATA,
                {
                    "printDataByNumber": num,
                    "printDetailsType": "hit_consignment"
                },
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

                        Accept: 'application/pdf'
                    }
                }, null
            )
            .then((response) => {
                setDownloadConsignment(response.data);
                const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                let iframe = document.createElement('iframe');
                document.body.appendChild(iframe);
                iframe.style.display = 'none';
                iframe.src = url;
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    function getUrnList() {
        loaderService.showLoader()
        apiClient
            .post(GET_URN_LIST,
                {
                    "stakeholderType": stakeholderType
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUrnList(response.data.urnNoList);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                toast.error(error.message);
            });
    }


    function searchConsignmentData(e) {
        e.preventDefault();
        getconsignmentDetails(selectedUrn, pickUpdate);
    }

    const clearSearch = () => {
        // e.preventDefault();
        setPickUpDate(null);
        setSelectedUrn('');
        getconsignmentDetails('', null);
    }

    const onTextValueChange = (e) => {
        setComments(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
    }

    const handleChangeType = (e) => {
        setStakeholderType(e.target.value);
    }
console.log("handleChangeType", stakeholderType)

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT03</p>}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    {
                        localStorage.getItem('role') == PIT_ROLES.PitScmUser || localStorage.getItem('role') == PIT_ROLES.TransportationIncharge ?
                            <Typography variant="h5" gutterBottom>Consignment Creation</Typography>
                            : <Typography variant="h4">
                                <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                                    <KeyboardArrowLeftRounded />
                                </Fab> Consignment Creation
                            </Typography>

                    }
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <>
                            <Stack direction="row" spacing={1}>
                                <Button sx={{ minWidth: 100 }} color="primary" variant="contained" onClick={(e) => viewurn(e, selectedConsignments)}>Create Consignment</Button>
                            </Stack>
                        </>
                    </Stack>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            {localStorage.getItem('role') == PIT_ROLES.PitScmUser || localStorage.getItem('role') == PIT_ROLES.TransportationIncharge ?
                                <>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size='small' error={noUrnError}>
                                            <InputLabel>Select StakeHolder</InputLabel>
                                            <Select value={stakeholderType} label="Select Stakeholder" onChange={(e) => handleChangeType(e)}>
                                                <MenuItem value='HIT'>HIT</MenuItem>
                                                <MenuItem value='Transporter'>Transporter</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size='small' error={noUrnError}>
                                            <InputLabel>Select URN</InputLabel>
                                            <Select value={selectedUrn} label="Select URN" onChange={onValueUrn}>
                                                <MenuItem value=''>Select</MenuItem>
                                                {urnList &&
                                                    urnList.map((urns) => (
                                                        <MenuItem value={urns}>{urns}</MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{noUrnError}</FormHelperText>
                                        </FormControl>

                                    </Grid>
                                </>
                                :
                                null}
                            <Grid item xs={12} lg={3}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Pick-Up Date"
                                            inputFormat="DD/MM/YYYY"
                                            value={pickUpdate}
                                            name="pickUpDate"
                                            onChange={(e) => handleDateChange(e)}
                                            sx={{ width: 260 }}
                                            renderInput={(params) => <TextField size='small' {...params} />}
                                            slots={{
                                                field: { clearButton: true },
                                            }}
                                        />


                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <Button variant="contained" color="primary" onClick={() => clearSearch()} >
                                    Clear Search
                                </Button>
                            </Grid>
                        </Grid>
                        <Typography variant="h5" gutterBottom mt={1}>Consignment Data</Typography>
                        {
                                                        selectedConsignments?.length > 0 &&
                                                        <Paper
                                                            elevation={2}
                                                            sx={{
                                                                p: 2,
                                                                mt: 2,
                                                                display: 'flex',
                                                                gap: 4,
                                                                backgroundColor: '#f8f9fa',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <Grid container spacing={2} alignItems="center">
                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography variant="body2" color="textSecondary">
                                                                        Selected Rows: <strong>{selectedConsignments.length}</strong>
                                                                    </Typography>
                                                                </Grid>
                        
                                                                <Grid item xs={12} sm={6}> <Typography variant="body2" color="primary">
                                                                    Sum of Balance Quantity: <strong>{totalQuantity.toFixed(4)} MT</strong>
                                                                </Typography></Grid>
                                                            </Grid>
                        
                        
                                                        </Paper>
                                                    }
                        <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                            <DataGrid
                                rows={consignmentDetails}
                                columns={columns}
                                pageSize={10}
                                getRowId={(row) => row.id}
                                components={{ Toolbar: QuickSearchToolbar }}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Container>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <ConfirmPopover title={cofirmMessage} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLogModalOpen(false)}>OK</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"

            >
                <DialogTitle id="alert-dialog-title"  >
                    <Typography variant='subtitle1' gutterBottom>Split Consignment</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography>Vehicle capacity is less than the total Quantity. Do you want to split ?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose1} autoFocus>No</Button>
                    <Button onClick={handleYes}>Yes</Button>


                </DialogActions>
            </Dialog>


            <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
                <DialogContent>
                    <Container maxWidth="xxl">
                        <Typography variant="h5" gutterBottom>Create Consignment Details</Typography>
                        {showErrorMsg != "" &&
                            <Typography sx={{ color: 'red' }}>{showErrorMsg}</Typography>
                        }
                        <Card>
                            <CardContent>
                                <Box style={{ height: 240, width: '100%' }}>
                                    <DataGrid
                                        rows={selectedConsignments}
                                        getRowId={(row) => row.id}
                                        columns={consDetailsCol}
                                        hideFooterPagination
                                    />
                                    <Typography style={{ float: "right", marginRight: "27%", marginTop: "5px" }}>Total Quantity(in MT): {totalQuantity}</Typography>
                                </Box>
                                <Grid container spacing={1} direction="row" mt={1}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} lg={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Vehicle Number</InputLabel>
                                                    <Select
                                                        label="Vehicle Number"
                                                        value={vehicleNo}
                                                        onChange={(e) => { updateVehicleDetails(e) }}
                                                    >
                                                        {vehicleList?.map(row =>
                                                            <MenuItem selected value={row.registrationNo}>{row.registrationNo}</MenuItem>
                                                        )}
                                                        {/* <MenuItem value={"0003"}>0003</MenuItem> */}

                                                    </Select>
                                                    {vehicleNoError != "" &&
                                                        <FormHelperText sx={{ color: 'red' }}>{vehicleNoError}</FormHelperText>
                                                    }
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <FormControl fullWidth>
                                                    <TextField fullWidth
                                                        label='Vehicle Capacityq(in MT)'
                                                        value={vehicleCapacity}
                                                        onChange={(e) => { e.target.value.length > 0 && setVehicleCapacityError(""); setVehicleCapacity(e.target.value.slice(0, 6)) }}
                                                        type="number"
                                                        onFocus={handleNumberFieldFocus}
                                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                                    />
                                                </FormControl>
                                                {vehicleCapacityError != "" &&
                                                    <FormHelperText sx={{ color: 'red' }}>{vehicleCapacityError}</FormHelperText>
                                                }
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Driver License Number</InputLabel>
                                                    <Select
                                                        label="Driver License Number"
                                                        value={driverlicensenumber}
                                                        onChange={(e) => { updateDriverDetails(e) }}
                                                    >
                                                        {driverList?.map(row =>
                                                            <MenuItem selected value={row.driverLicenseId}>{row.driverLicenseId}</MenuItem>
                                                        )}
                                                    </Select>
                                                </FormControl>
                                                {driverlicensenumberError != "" &&
                                                    <FormHelperText>{driverlicensenumberError}</FormHelperText>
                                                }
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <FormControl fullWidth>
                                                    <TextField label='Driver Name' disabled value={driverName} onChange={(e) => { e.target.value.length > 0 && setDriverNameError(""); setDriverName(e.target.value) }} type="text" />
                                                </FormControl>
                                                {driverNameError != "" &&
                                                    <FormHelperText sx={{ color: 'red' }}>{driverNameError}</FormHelperText>
                                                }

                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <FormControl fullWidth >
                                                    <TextField label='Driver Contact' disabled value={driverContact} onChange={(e) => { e.target.value.length > 0 && setDriverContactError(""); setDriverContact(e.target.value) }} type="text" />
                                                </FormControl>
                                                {driverContactError != "" &&
                                                    <FormHelperText sx={{ color: 'red' }}>{driverContactError}</FormHelperText>
                                                }
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <TextField fullWidth
                                                    autoComplete="off"
                                                    id="outlined-multiline-static"
                                                    label={t('reg.comment')}
                                                    multiline
                                                    inputProps={{ maxLength: 500 }}
                                                    // value={comments}
                                                    // onChange={(e) => setComments(e.target.value)}
                                                    type="text"
                                                    onChange={(e) => onTextValueChange(e)}
                                                    value={comments}
                                                // onKeyDown={(evt) => regex && evt.preventDefault()}
                                                />
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Badge bg={`${comments?.length > characterLimit ? 'danger' : 'primary'}`}>{comments?.length}/{characterLimit}</Badge>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                    </Container>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={1} style={{ float: "right" }}>
                        <Button variant='contained' sx={{ minWidth: 100 }} onClick={handleClose} >Cancel</Button>
                        <Button variant='contained' sx={{ minWidth: 100, ml: 1 }} onClick={onSaveButtonClick}>Save</Button>
                    </Box>
                    <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirm} onClose={handleConfirmClose} action="Create Consignment" />
                </DialogContent>

                {/* <DialogContent>
                    {showErrorMsg != "" &&
                        <Row>
                            <Col xs={12} md={12} sm={12}>
                                <p style={{ marginLeft: "40px", marginBottom: "2%", color: "red" }}>{showErrorMsg}</p>

                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col xs={12} md={12} sm={12}>
                            <TableContainer >
                                <Table sx={{
                                    minWidth: 100, borderSpacing: "2px", width: "88%",
                                    border: "grey 1px Solid", borderRadius: "1vh", marginLeft: "9%"
                                }} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell textAlign="center"> Scheduled Pick-Up Location</StyledTableCell>
                                            <StyledTableCell textAlign="center">Delivery Location</StyledTableCell>
                                            <StyledTableCell textAlign="center">Balance Quantity</StyledTableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedConsignments && selectedConsignments.map((row) => (
                                            <StyledTableRow key={row.sno}>
                                                <StyledTableCell textAlign="center" >{row.pickUpLocationName}</StyledTableCell>
                                                <StyledTableCell textAlign="center" >{row.deliveryLocationName}</StyledTableCell>
                                                <StyledTableCell textAlign="center" >{row.scheduleWeight}</StyledTableCell>



                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} sm={12}>
                            <div style={{ float: "right", marginRight: "14%", marginTop: "5px" }}>Total Quantity:{totalQuantity}</div>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col xs={12} md={6} sm={6}>

                            <div style={{ marginLeft: "10px", width: "100%" }} >
                                <p style={{ marginLeft: "25px", marginBottom: "0rem" }}>Vehicle Number</p>
                               
                                <FormControl>
                                    <InputLabel>Vehicle Number</InputLabel>
                                    <Select
                                        label="Vehicle Number"
                                        value={vehicleNo}
                                        onChange={(e) => { updateVehicleDetails(e) }}
                                    >
                                        {vehicleList?.map(row =>
                                            <MenuItem selected value={row.registrationNo}>{row.registrationNo}</MenuItem>
                                        )}

                                    </Select>

                                </FormControl>

                                {vehicleNoError != "" &&
                                    <p style={{ marginLeft: "25px", marginBottom: "2%", color: "red", fontSize: "2vh" }}>{vehicleNoError}</p>
                                }

                            </div>

                        </Col>

                        <Col xs={12} md={6} sm={6}>
                            <div style={{ marginLeft: "10px", width: "70%" }} >
                                <p style={{ marginLeft: "25px", marginBottom: "0rem" }}>Vehicle Capacity</p>
                                <FormControl style={{ margin: "0px !important", width: "50px !important" }} fullWidth>

                                    <TextField size="small" id="vehicle capacity" value={vehicleCapacity} onChange={(e) => { e.target.value.length > 0 && setVehicleCapacityError(""); setVehicleCapacity(e.target.value) }} type="text" maxLength={6} />
                                </FormControl>
                                {vehicleCapacityError != "" &&
                                    <p style={{ marginLeft: "25px", marginBottom: "2%", color: "red", fontSize: "2vh" }}>{vehicleCapacityError}</p>
                                }
                            </div>
                        </Col>

                    </Row>
                    <br></br>
                    <Row>
                        <Col xs={12} md={6} sm={6}>

                            <div style={{ marginLeft: "10px", width: "80%" }} >
                                <p style={{ marginLeft: "25px", marginBottom: "0rem" }}>Driver License Number</p>
                                <FormControl style={{ margin: "0px !important", width: "50px !important" }} >
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={driverlicensenumber}
                                        onChange={(e) => { updateDriverDetails(e) }}

                                        style={{ marginLeft: "12px", height: "5.7vh", width: "13vw" }}

                                    >
                                        {driverList?.map(row =>
                                            <MenuItem selected value={row.driverLicenseId}>{row.driverLicenseId}</MenuItem>
                                        )}



                                    </Select>

                                </FormControl>
                                {driverlicensenumberError != "" &&
                                    <p style={{ marginLeft: "25px", marginBottom: "2%", color: "red", fontSize: "2vh" }}>{driverlicensenumberError}</p>
                                }


                            </div>

                        </Col>


                        <Col xs={12} md={6} sm={6}>
                            <div style={{ marginLeft: "10px", width: "70%" }} >
                                <p style={{ marginLeft: "25px", marginBottom: "0rem" }}>Driver Name</p>
                                <FormControl style={{ margin: "0px !important", width: "50px !important" }} fullWidth>

                                    <TextField size="small" disabled value={driverName} onChange={(e) => { e.target.value.length > 0 && setDriverNameError(""); setDriverName(e.target.value) }} type="text" />
                                </FormControl>
                                {driverNameError != "" &&
                                    <p style={{ marginLeft: "25px", marginBottom: "2%", color: "red", fontSize: "2vh" }}>{driverNameError}</p>
                                }


                            </div>
                        </Col>

                    </Row>
                    <br></br>
                    <Row>
                        <Col xs={12} md={6} sm={6}>

                            <div style={{ marginLeft: "10px", width: "80%" }} >
                                <p style={{ marginLeft: "25px", marginBottom: "0rem" }}>Driver Contact</p>
                                <FormControl style={{ margin: "0px !important", marginLeft: "10px", width: "50px !important" }} >
                                    <TextField size="small" disabled value={driverContact} onChange={(e) => { e.target.value.length > 0 && setDriverContactError(""); setDriverContact(e.target.value) }} type="text" />
                                </FormControl>
                                {driverContactError != "" &&
                                    <p style={{ marginLeft: "25px", marginBottom: "2%", color: "red", fontSize: "2vh" }}>{driverContactError}</p>
                                }

                            </div>

                        </Col>

                        <Col xs={12} md={6} sm={6}>

                            <div style={{ marginLeft: "10px", width: "70%" }} >
                                <p style={{ marginLeft: "25px", marginBottom: "0rem" }}>Comments</p>
                                <FormControl style={{ margin: "0px !important", width: "50px !important" }} >
                                    <TextField value={comments} onChange={(e) => setComments(e.target.value)} type="text" />
                                </FormControl>

                            </div>

                        </Col>
                 

                    </Row>

                </DialogContent>
                <DialogActions>
                    <Button variant='contained' sx={{ minWidth: 100 }} onClick={handleClose} >Cancel</Button>
                    <Button variant='contained' sx={{ minWidth: 100 }} onClick={handleSave}>Save</Button>
                </DialogActions> */}
            </Dialog>
        </>
    )
}